var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "table-heading mb-0 p-3 flex align-items-center justify-content-between",
        },
        [
          _vm._t("table-heading", function () {
            return [
              _c("h1", { staticClass: "title mb-0 fs-20 fw-500" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _vm.addButton
                ? _c(
                    "button",
                    {
                      staticClass: "custom-btn add-new-btn add-secondery",
                      on: { click: _vm.addButton.onClick },
                    },
                    [
                      _c("i", { staticClass: "fas fa-plus" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.addButton.text || "إضافة") +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-filters p-3" }, [_vm._t("filters")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive p-3" }, [
        _c("table", { staticClass: "table studentsTrips-table" }, [
          _c(
            "thead",
            { staticClass: "thead-light" },
            [
              _vm._t("thead", function () {
                return [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.columns, function (col, idx) {
                        return _c(
                          "th",
                          { key: idx, attrs: { width: col.width } },
                          [_vm._v(_vm._s(col.label))]
                        )
                      }),
                      _vm._v(" "),
                      _vm.$scopedSlots.actions ? _c("th") : _vm._e(),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._t("tbody", function () {
                return [
                  !_vm.items || _vm.items.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: {
                              colspan:
                                _vm.columns.length +
                                (_vm.$scopedSlots.actions ? 1 : 0),
                            },
                          },
                          [
                            _vm._v(
                              "\n              لا توجد نتائج\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.items, function (item, idx) {
                    return _c(
                      "tr",
                      { key: item.id || idx },
                      [
                        _vm._l(_vm.columns, function (col, cidx) {
                          return _c(
                            "td",
                            { key: cidx },
                            [
                              _vm._t(
                                col.key,
                                function () {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item[col.key]) +
                                        "\n              "
                                    ),
                                  ]
                                },
                                { item: item, value: item[col.key] }
                              ),
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _vm.$scopedSlots.actions
                          ? _c(
                              "td",
                              [_vm._t("actions", null, { item: item })],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.pagination && _vm.pagination.total > 1
        ? _c("pagination-teacher", {
            attrs: {
              current: _vm.pagination.current,
              total: _vm.pagination.total,
            },
            on: { "page-change": _vm.changePage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }